import type { InjectionKey, Ref } from 'virtual-vue';
import { inject } from 'virtual-vue';
import type { TabsIndex, TabsSize, TabsType, TabsBackground } from './tabs';

export const TABS_INJECT_KEY: InjectionKey<TabsProvide> = Symbol('tabs');

export interface TabsProvide {
  activeIndex: Ref<TabsIndex>;
  size: Ref<TabsSize>;
  type: Ref<TabsType>;
  background: Ref<TabsBackground>;
  activeColor?: Ref<string | undefined>;
  inactiveColor?: Ref<string | undefined>;
  updateActive: (index: TabsIndex, title?: string) => void;
}

export function useTabsInject() {
  const tabsProvide = inject<TabsProvide>(TABS_INJECT_KEY);
  if (!tabsProvide) {
    throw new Error('useTabsInject must be used within Tabs component');
  }
  return tabsProvide;
}

